var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-chart-2"},[_c('div',{staticClass:"lc2-header"},[_vm._v("快递平台接单占比")]),_c('div',{staticClass:"lc2-details"},[_vm._v("快递平台总数"),_c('span',[_vm._v(_vm._s(_vm.companysTotal))])]),_c('div',{attrs:{"id":"company"}}),_c('dv-decoration-2',{staticStyle:{"height":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }